import { Box, Typography } from "@mui/material";
import React from "react";
import WithLove from "../../common/components/WithLove";
import dayOneImg from "../../images/day-one.jpg";
import dayOne from "../../images/day1.png";
import menorah from "../../images/MenorahDayOne.png";
import creation from "../../images/creation.png";
import interacting from "../../images/interacting.png";
import tabernacle from "../../images/Tabernacle.png";
import Topic from "../../common/components/Topic";
import Picture from "../../common/components/Picture";
import Title from "../../common/components/Title";
import Content from "../../common/components/Content";
import Subtitle from "../../common/components/Subtitle";
import Text from "../../common/components/Text";
import Bullet from "../../common/components/Bullet";
import SubSection from "../../common/components/SubSection";
import Section from "../../common/components/Section";
import Number from "../../common/components/Number";
import Italics from "../../common/components/Italics";

export default function DayOne() {
  return (
    <>
      <Box>
        <Topic>Understanding the Kingdom</Topic>
        <Text>John 3:3-5, Rom. 14:17, 2 Pet. 1:11</Text>
        <br />
      </Box>
      <Picture src={dayOne} />
      <Section>
        <SubSection>
          <Title>Study Background</Title>
          <Content>
            You are welcome to <b>Gadites Bible Seminar 3.0</b>.
            <br />
            <br />
            We thank Our Lord Jesus Christ for previous Gadites Bible Seminars
            and the blessing of growth that has occurred in our lives ever
            since. In this year&rsquo;s bible seminar, by the grace of God,
            under our parents in the Lord, we will be expounding the subject of
            the Everlasting Kingdom. To be able to gain appreciable
            understanding of this subject, it is necessary to provide a
            comprehensive study background.
          </Content>
          <Content>
            <br />
            In this section, we desire to consider God&rsquo;s original intent
            for man to inherit his own Kingdom, man&rsquo;s fall from this
            purpose, and how God, through the new birth, restored his eternal
            plan for man in Christ Jesus. We trust the Holy Ghost to open our
            understanding to the reality of the pursuit of his dominion in Jesus
            name.
          </Content>
        </SubSection>
        <br />
        <SubSection>
          <Subtitle>Man was made for God&rsquo;s Dominion</Subtitle>
          <br />
          <Picture src={creation} />
          <br />
          <Content>
            In the beginning, God created two major habitations &#x002D; the
            heaven and the earth <b>(Gen. 1:1, Heb 1:10)</b>. Over these
            habitations, God delegated authority to created beings to govern and
            rule. Over the realms of the heavens, God created Angels (heavenly
            men) to rule and over the earthy realm, God created Adam (earthy
            man) to govern; however, God&rsquo;s own dominion rules over them
            all <b>(Psalm 103:19-22)</b>.<br />
            <br /> It is important to note that although God gave man dominion
            in the beginning, this dominion was limited to the earth and thus,
            was not God&rsquo;s very dominion, which rules over all; this is
            clear in scriptures by the following reasons.
          </Content>
          <Box>
            <Bullet>
              First, we can observe from Genesis that image is first created
              before dominion is given. This is because dominion rests on image.
              In other words, the image kind determines the nature and scope of
              the dominion delegated by God. Carefully looking at Genesis
              1:26-27, we see that Adam was made &#8220;in the image&#8221; and
              not &#8220;the image&#8221; of God.
              <br />
              <br />
              However, our Lord Jesus Christ in the Epistles is described as
              having &#8220;the image of God&#8221; <b>(2 Cor. 4:4)</b>,
              &#8220;the image of the invisible God&#8221; <b>(Col. 1:15)</b>,
              or &#8220;the express image of his person&#8221; <b>(Heb. 1:3)</b>
              . This is the first proof that although God gave Adam an image and
              dominion, he still had a destiny to attain unto the exact image
              and dominion of God. <b>(Rom. 8:22-29)</b>.
            </Bullet>
            <br />
            <Bullet>
              Second, from 1 Cor. 15:44-49, it is clear that Adam is referred to
              as a &#8220;living soul&#8221;, while our Lord Jesus is referred
              to as a &#8220;quickening spirit&#8221;. In addition, the image
              quality of Adam is called &#8220;earthy&#8221;; thus, the scope of
              Adam&rsquo;s dominion was over the earth{" "}
              <b>(Gen. 1:26, Psalm 8:5-8)</b>. <br />
              <br />
              Meanwhile, the image quality of Jesus is above the heavens; thus,
              Jesus&rsquo; dominion is over all <b>(Heb. 2:7-1-10)</b>. This
              further affirms the truth that God&rsquo;s expectation for Adam
              was to grow in image until he attains God&rsquo;s express image
              where he will also rule over all.
            </Bullet>
            <br />
            <Bullet>
              In <b>Psalm 8:5</b>, we see that Adam was made “a little lower”
              than the Angels. However, it is evident that God is the most high.
              Thus, if Adam was made God&rsquo;s exact image, he should not be a
              little lower than the angels. Interestingly, our Lord Jesus Christ
              (the express image of God), in <b>Hebrews 1:4</b>, is declared to
              be “so much better” than the Angels. it is clear that Adam was not
              made the exact image of God. Rather, he was created a shadow of
              God&rsquo;s very image (hence the phrase, “in the image”). <br />
              <br />
              In addition, the fact that Adam could be tempted shows that he was
              not God&rsquo;s exact image because God cannot be tempted{" "}
              <b>(James 1:13)</b>. More so, Adam could be and was corrupted but
              God is uncorruptible <b>(Rom. 1:23)</b>.
            </Bullet>
          </Box>
          <br />
          <Content>
            All these prove to us that although God created Adam and gave him
            dominion, yet he still had an expectation for him. More so, the
            eternal purpose of God was for Adam to conform to the express image
            of his Son <b>(Rom. 8:29)</b>, so he could have God&rsquo;s own very
            dominion, which rules over all.
          </Content>
        </SubSection>
        <br />
        <SubSection>
          <Subtitle>The Fall from the Pursuit of God&rsquo;s Dominion</Subtitle>
          <Content>
            To achieve the express image of God, God put Adam into a garden of
            trees, where also grew the tree of life and the tree of the
            knowledge of good and evil. God commanded him to eat of all trees
            except the tree of knowledge of good and evil <b>(Gen. 2:8-9)</b>.
            This is because this evil tree had the poison of death in it
            (&#8220;For in the day that thou eatest thereof, thou shalt surely
            die&#8221;) <b>(Gen. 2:8-9, 15-17)</b>. Man disobeyed God&rsquo;s
            commandment by partaking of the tree and from then on, a downward
            spiral began. <br />
            <br />
            To understand the consequence of man&rsquo;s disobedience, we must
            reiterate again that man is essentially a &#8220;spirit being&#8221;
            that has a &#8220;soul&#8221; and lives in a &#8220;physical
            body&#8221;.{" "}
            <b>
              (Heb. 4:12, 1 Thess. 5:23, Luke 23:46, Mark 14:34, Matt. 27:39)
            </b>
            . The death of man was instantaneous and it occurred in his spirit;
            however, the fall of man was gradual and it occurred in his soul.
            <br />
            <br />
            The fall of man, which was a soul evolution in the process of time,
            led to a loss in the dominion God gave him and change in pursuit
            from seeking God&rsquo;s dominion to seeking things of the earth
            <b>(Gen. 6:3, Rom. 3:23, Eccl. 3:18, Matt. 6:26-34).</b> Thus,
            informing the need for a plan of redemption.
          </Content>
        </SubSection>
        <br />
        <SubSection>
          <Subtitle>
            The New Birth &ndash; a Restoration to the Pursuit of God&rsquo;s
            dominion
          </Subtitle>
          <Italics fontWeight="regular">
            &#8220;Except a man is born again, he cannot see the kingdom of
            God&#8221;
          </Italics>
          <Content>
            The coming of our Lord Jesus to the earth was to initiate the long
            lost purpose of man (2 Tim. 1:9). This is clear from his herald
            &ndash; &#8220;for the kingdom of heaven is at hand&#8221;. The very
            purpose of the new birth is nothing else but the kingdom of God.
            Through the years, God&rsquo;s plan remained unchanged. In the New
            Testament dispensation, God, through our Lord Jesus, has restored
            man&rsquo;s original pursuit. <br />
            <br />
            Thus, the essence of being born again, the sending of the Holy
            Ghost, the ministry gifts, the church, etc. is for the saints of the
            most high to ultimately possess the kingdom
            <b> (Dan. 7:18)</b>. We trust the grace of God to remove veils that
            Satan has created to deviate us from this pursuit and set our hearts
            on course the everlasting kingdom of God.
          </Content>
        </SubSection>
      </Section>
      <Section>
        <SubSection>
          <Title>Defining Kingdom</Title>
          <Content>
            The word &#8220;kingdom&#8221; is a combination of two unique words
            &ndash; &#8220;king&#8221; and &#8220;domain&#8221;. Precisely,
            &#8220;King&#8221; speaks of a person, while &#8220;domain&#8221;
            refers to a sphere of influence. In simpler terms, kingdom can be
            defined as a domain or sphere where the life of a king is being
            expressed. Thus, the keyword in defining kingdom is expression of
            life. <br />
            <br />
            In sum, the sphere where a King&rsquo;s dominion or lifestyle finds
            expression is kingdom. For example, Yoruba kingdom refers to a
            sphere where a particular culture of life finds expression. Thus,
            the kingdom of God is a sphere where the life of God finds
            expression <b>(Matt. 20:25-27, Mark 10:42-44)</b>.
          </Content>
        </SubSection>
      </Section>
      <Section>
        <SubSection>
          <Title>What the kingdom of God is not</Title>
          <Content>
            Over time, Satan has veiled the minds of men with diverse
            definitions as to what kingdom is. This has tilted men to wrong
            pursuits in search of power, wealth, prominence, and even anointing.
            Here, we seek to clear out these misconceptions to what the kingdom
            of God is.
          </Content>
        </SubSection>
        <SubSection>
          <Number number={1}>
            <b>The Kingdom of God is not a geographical location.</b> It is a
            popular misconception that the kingdom of God is heaven. It is good
            to know that while heaven is a geographical location, the kingdom of
            God is not a place; rather it is the expression of God&rsquo;s life.
            In addition, heaven was created in Genesis 1:1, but the kingdom of
            God has been before the world began. More so, while the heavens will
            pass away, the kingdom of God abides forever. When a believer sleeps
            in the Lord, his spirit ascends to heaven. However, from the prayer
            of our Lord Jesus, the kingdom of God is meant to come down to the
            earth.{" "}
            <b>
              (Heb. 1:10-11, Matt. 25:34, Matt. 6:10, Rev. 20:11, Heb. 12:28, 2
              Pet. 3:10)
            </b>
            .
          </Number>
          <br />
          <Number number={2}>
            <b>
              The Kingdom of God is not taking over the seven mountains of the
              world.
            </b>{" "}
            Another renowned misconception as regards the kingdom is that of
            taking over spheres of influence in this present world. However, our
            Lord Jesus himself declared that his kingdom is not of this world{" "}
            <b>(John 18:36)</b>. Moreover, when Satan showed him all the
            kingdoms of the world and the glories of them, he refused them. In
            Rev. 11:15 and Isa 2:2-3, the mountain of the Lord&rsquo;s house
            being exalted above the mountains is the season when the knowledge
            or life of God would be exalted among the nations, converting souls
            to righteousness.{" "}
            <b>
              (Matt. 4:8, Rev. 11:15, Isa. 2:2-3, 25:6-7, Dan. 1:8, 6:3, 10:2-3,
              Hab. 2:14, Heb. 11:26, 2 Cor. 10:5)
            </b>
            .
          </Number>
          <br />
          <Number number={3}>
            <b>
              The Kingdom of God is not the manifestation of gifts of the
              Spirit.
            </b>{" "}
            Some schools of thought believe that the manifestation of the gifts
            of the Spirit is exercising the dominion of God on earth. However,
            careful study of scripture shows that the kingdom of God is distinct
            from the gifts of the Spirit. While the gifts of the Spirit are a
            consequence of the fall of man, the kingdom of God has been before
            the fall.
            <br />
            <br />
            Notwithstanding, the gifts of the Spirit can witness to the gospel
            of the kingdom. However, this is in the discretion and sovereignty
            of the Almighty God. The kingdom of God can thrive with or without
            the gifts of the Spirit because it is the expression of God&rsquo;s
            life. <b>(Matt. 7:22-23, 1 Cor. 12:11, Heb. 2:3-4)</b>.
          </Number>
          <br />
          <Number number={4}>
            <b>The Kingdom of God is not natural prosperity.</b> Truly, it is
            God&rsquo;s desire that the believer prospers in the spiritual and
            in the natural. However, prosperity in the natural has never been an
            evidence of the kingdom of God because even unbelievers experience
            natural prosperity. Moreover, the conversation of our Lord Jesus on
            earth is an undeniable proof of this as Jesus lived a contented
            life, allowing God to meet his needs.
            <br />
            <br />
            As an emphasis, Paul admonished the believers to be content having
            food and raiment. More so, the rich young ruler could not follow the
            Lord because of his natural wealth. Thus, it is clear that natural
            prosperity is not a validation of the kingdom.{" "}
            <b>(Matt. 6:20, 2 Cor. 9, Phil. 2:5-12)</b>.
          </Number>
          <br />
          <Number number={5}>
            <b>The Kingdom of God is not ministry.</b> Many believers are very
            zealous about populating the kingdom of God and depopulating the
            kingdom of darkness. As sincere as this desire is, it is good to
            know this is not what the kingdom of God is primarily about. It is
            important to preach the gospel of our Lord Jesus to others to get
            them born again and part of the church, but being born again does
            not make you a part of the kingdom. <br />
            <br />
            In fact, the kingdom of God is primarily for believers to enter and
            not for unbelievers. Unbelievers need to be quickened but believers
            need to press into the kingdom of God. It is possible to be a great
            preacher and miss out on the kingdom of God{" "}
            <b>(Matt. 7:22-23, 1 Tim. 4:16, 1 Cor. 9:27)</b>.
          </Number>
          <br />
        </SubSection>
        <Content>
          Having cleared the misconceptions of what the kingdom of God is all
          about, it is necessary to provide a comprehensive understanding of
          what the kingdom truly is that our hearts might be spurred in pursuit
          of God&rsquo;s dominion.
        </Content>
      </Section>
      <Section>
        <SubSection>
          <Title>What the kingdom of God is</Title>
          <br />
          <Picture src={tabernacle} />
          <br />
          <Content>
            As established earlier, Kingdom is an expression of life. According
            to <b>Romans 14:17</b>, the kingdom of God is explicitly defined as
            Righteousness and Peace and Joy, in the Holy Ghost. The conjunction
            &#8220;and&#8221; affirms that these three are distinct. Thus, the
            kingdom of God is one thing but in different levels.
            <br />
            <br /> In simpler terms, we can say that in the kingdom of God,
            there are three distinct expressions of life. This infers that there
            are measures of life in the kingdom, which begins with
            righteousness, after which we attain a higher measure of life called
            peace, and the fullness of the kingdom is joy.
          </Content>
          <br />
          <Content>
            Meanwhile, you cannot separate the kingdom of God from the will of
            God because it takes doing the will of God to enter into the
            kingdom. More so, when Jesus prayed, he said &#8220;thy kingdom
            come, thy will be done&#8221;. Thus, if there are three levels of
            life in the kingdom of God, there should be three levels to the will
            of God <b>(Matt. 7:21)</b>. Interestingly, Paul speaking to the{" "}
            <b>Romans 12:2</b>, spelt out three levels to discerning the will of
            God &ndash; the good will and acceptable will and perfect will, of
            God.
            <br />
            <br /> This further establishes that as the kingdom of God is in
            three levels, the will of God is also in three levels. It is good to
            point out here that the sense of doing the will is not one of
            decision-making, rather, it is a work like Jesus said in{" "}
            <b>John 4:34</b>. <br />
            <br />
            In sum, a believer that has done the good will has the measure of
            life called Righteousness. The doing of the acceptable will brings a
            believer to express the measure of life called Peace. Lastly, the
            doing of perfect will is initiates the expression of the measure of
            life called Joy.
          </Content>
          <br />
          <Content>
            In scriptures, there are diverse examples that shadow these
            divisions in the Kingdom of God. Of these examples, we have selected
            three explained as follows
          </Content>
        </SubSection>
        <SubSection>
          <Number number={1}>
            <b>
              The clearest shadow of God&rsquo;s Kingdom is the heavens (Ps.
              103:19).
            </b>{" "}
            In <b>Matthew 6:10</b>, Jesus prayed for the Kingdom of God to come
            and that the will of God be done in earth <b>AS IT IS IN HEAVEN</b>.
            The adverb &#8220;as&#8221; is used to introduce a comparison or
            similarity between two things. Hence, it means there is a pattern of
            the will and kingdom of God in the Heavens. <br />
            <br />
            Interestingly, the Heavens, according to scriptures, can be divided
            into three. In <b>2 Corinthians 12:2</b>, Paul mentioned an
            experience where he was caught up to the third heaven. Now, if there
            is a third heaven, there must be a first and second heaven.
            <br />
            <br /> More so, the division in <b>Psalms 103:20-22</b>, when
            expounding the inhabitants of the heavens, identifies three separate
            angelic kingdoms in a descending order, doing three different works
            or will. These entities are &ndash; Angels, Hosts, and Works. This
            shows us that even the realm of the angelic is ordered in the
            pattern of the kingdom of God.
          </Number>
          <br />
          <Number number={2}>
            <b>Another shadow of the kingdom is the Tabernacle of Moses</b>,
            which was made according to the pattern of the Heavens God revealed
            to Moses in the mount <b>(Heb. 8:5)</b>. The tabernacle is divided
            into three major compartments: The Court, the Sanctuary, and the
            Holiest of all <b>(Heb. 9:1-5)</b>. The Court is the place of
            Righteousness, Sanctuary is the place of Peace and Holiest of all is
            the place of Joy. <br />
            <br />
            According to <b>Psalms 16:11</b>, in the presence of God there is
            fullness of Joy. This means the presence of God is where the full
            manifestation of the life of the kingdom is expressed. More so, the
            priests that serve the tabernacle are ordered in three groups
            &ndash; the Levites, the sons of Aaron (Priests), and Aaron (the
            High priest). Precisely, while the Levites serve in the court, the
            Priests serve in the Sanctuary, and the High priest only enters into
            the Holiest of all once every year <b>(Heb. 9:6-8)</b>. This further
            establishes the three divisions of the heavens, the angels, and
            ultimately the kingdom of God.
          </Number>
          <br />
          <Number number={3}>
            <b>
              The third shadow is the order of Melchizedek mentioned in Hebrews
              7
            </b>
            . Melchizedek, although a man that met Abraham, is beyond a person,
            but much more speaks of an order in the spirit. This order being the
            order of the kingdom of God. God declared our Lord Jesus Christ, a
            priest after the order of Melchizedek <b>(Heb. 5:5)</b>.
            <br />
            <br />
            The interpretation of Melchizedek is King of righteousness, king of
            Peace, priest of the most high God <b>(Heb. 7:1)</b>. This affirms
            the divisions and levels of the kingdom of God as seen in
            scriptures.
          </Number>
          <br />
          <Number number={4}>
            <b>God&rsquo;s promise to his covenant people (Israel)</b>. In
            <b> Exodus 19:6</b>, we find God making a promise to his covenant
            people God promised to make of them a holy nation, a kingdom of
            priests, and the peculiar treasure. Peter referring to this in 1
            Pet. 2, reveals that this promise of God did not end with his
            covenant people on earth but also remains God&rsquo;s plan for the
            church. <br />
            <br />
            These three divisions further confirms to us that the kingdom of God
            is divided into three domains &ndash; righteousness (holy nation),
            peace (kingdom of priests), and joy (peculiar treasure). Kindly note
            that this is what God seeks to make of &#8220;his people&#8221;.
            This means being born again is not an end in itself but a privilege
            for the saint to be made a people of the kingdom of God.
          </Number>
        </SubSection>
        <br />
        <Content>
          Interestingly, the kingdom of God can also be divided into two
          divisions &ndash; the kingdom of Christ and God <b>(Eph. 5:5)</b>.
          More precisely, the kingdom of Christ is righteousness and peace,
          while the kingdom of God is Joy <b>(Rom. 8:6, 10, 1 Cor. 10:3-4)</b>.
          The kingdom of Christ is the way to access the kingdom of God as Jesus
          declared, &#8220;I am the way, the truth, the life, no man cometh to
          the Father but by me&#8221; <b>(John 14:6)</b>. <br />
          <br />
          To prove this, we find that in the tabernacle of Moses, God inhabited
          the holiest of all, showing that the Holiest of hall is the actual
          kingdom of God. However, to access the Holiest of all, you need to go
          through the court and the sanctuary. Thus, the court and the sanctuary
          are the way to the holiest and can be seen as the kingdom of Christ.
        </Content>
      </Section>
      <Section>
        <SubSection>
          <Title>The kingdom is in the Holy Ghost</Title>
          <Picture src={menorah} />
          <br />
          <Content>
            According to <b>Romans 14:17</b>, the kingdom of God is in the Holy
            Ghost. This shows us that the kingdom of God is in the custody of
            the Holy Ghost. Hence, to enter the kingdom is to journey into the
            Holy Ghost. At new birth, the Holy Ghost quickens and indwells the
            spirit of the believer. <br />
            <br />
            Some people erroneously believe that &#8220;since the Holy Ghost is
            in me, then I am in the kingdom&#8220;. However,{" "}
            <Typography variant="body2" display="inline" fontStyle="oblique">
              <b>
                the Holy Ghost in you is distinct from you in the Holy Ghost
              </b>
            </Typography>
            . Truly, the indwelling of the Holy Ghost provides the believer a
            possibility of partaking in the kingdom. However, it is not
            automatic. This is because to enter the kingdom, the believer needs
            to do the will of God, and to do the will, the believer needs to
            know the will <b>(Matt. 7:21, Col. 1:9)</b>. <br />
            <br />
            Thus, there are spiritual realities that precedes the
            believer&rsquo;s partaking of the kingdom.
          </Content>
          <br />
          <Content>
            First, the believer needs to hear the gospel of the kingdom, see the
            kingdom, seek the kingdom, and enter the kingdom. The Holy Ghost
            works these spiritual realities as the seven spirits of the Lord.
            Specifically, the seven spirits of the Lord is the Holy Ghost
            manifesting himself in a manner as to reveal the things of the
            kingdom. <br />
            <br />
            It is good to know that the Holy Ghost does this only by the
            permission of the Father, who is the owner of the kingdom. The Holy
            Ghost gives the spirit of wisdom and revelation to make the believer
            see the kingdom; then the spirit of counsel and might to seek and
            enter the kingdom; and the spirit of knowledge and fear to inherit
            the kingdom. <b>(Isa. 11:1-2, Eph. 1:17, Eph. 3:16, Eph. 5:21)</b>.
          </Content>
        </SubSection>
      </Section>
      <Picture src={dayOneImg} />
      <br />
      <Section>
        <SubSection>
          <Title>Interacting with the kingdom</Title>
          <br />
          <Picture src={interacting} />
          <br />
          <Italics>
            &#8220;Ask and ye shall receive, seek and ye shall find, knock and
            the door shall be opened unto you&#8221;
          </Italics>
          <Content>
            The above statement made by the Lord Jesus is strictly a kingdom
            statement. This is because what he was teaching in{" "}
            <b>Matthew 5-7</b> was mainly the kingdom of God. Thus, what the
            scriptures speaking about asking is for sight to see the kingdom,
            after which the believer begins to seek the kingdom by doing the
            will of God, and finally knock the door of the kingdom to be granted
            entrance. <br />
            <br />
            Below we have provided a comprehensive explanation of what each
            experience depicts according to the scriptures.
          </Content>
        </SubSection>
        <SubSection>
          <Subtitle>Seeing the Kingdom of God</Subtitle>
          <Content>
            In <b>John 3</b>, Jesus explained that the first interaction with
            the kingdom is to sight the kingdom. It is good to know that to see
            the kingdom is not to see with one&rsquo;s physical eyes but the
            eyes of one&rsquo;s understanding. Thus, to see the kingdom is to
            comprehend the kingdom <b>(Matt. 13:15, Acts 28:26-27)</b>.<br />
            <br /> However, you cannot see what you have not first heard. To
            hear the kingdom, a preacher must have preached the gospel of the
            kingdom to you <b>(John 3:3, Rom. 10:9-10, Acts 14:22)</b>. It is in
            the preaching of the kingdom that the Holy Ghost gives the spirit of
            wisdom and revelation to see or comprehend the kingdom{" "}
            <b>(Eph. 1:17-18)</b>.
          </Content>
          <br />
          <Content>
            To preach the gospel of the kingdom in the church, our Lord Jesus
            Christ gave ministry gifts to the saints saddled with the
            responsibility of preaching and teaching <b>(Acts 20:28)</b>. These
            gifts are the fivefold ministry (Apostles, Prophets, Evangelists,
            Pastors and Teachers). Examples of those that preached and taught
            the kingdom are Jesus <b>(Matt. 9:35, Mark 1:14)</b>, and Apostle
            Paul <b>(Acts 20:25, Acts 28:31)</b>.<br />
            <br /> In Epistle terms, seeing the kingdom is comprehending what
            the hope of God&rsquo;s calling is, the riches of God&rsquo;s
            inheritance, and the greatness of God&rsquo;s power{" "}
            <b>(2 Thess. 2:14, 1 Thess. 5:9, 2 Tim. 2:10, Eph.1:18)</b>. Seeing
            the kingdom is having redefinitions of hope, inheritance, and power.
            It is good to point out that seeing the kingdom is also not
            instantaneous, but a gradual process of enlightenment.
          </Content>
        </SubSection>
        <SubSection>
          <Subtitle>Seeking the Kingdom of God</Subtitle>
          <Content>
            To advance towards the kingdom, the believer needs to seek the
            kingdom <b>(Matt. 13:45)</b>. Seeking is an active word and it
            involves doing something. <b>(Matt. 6:31-33)</b>. Actually, seeking
            the kingdom is obeying the dictates of the will of God or
            righteousness to find the gates of the kingdom. <br />
            <br />
            Seeking the kingdom is obeying the demands of the Spirit to convert
            the soul from living after vanity to living for the kingdom.{" "}
            <b>(Matt. 6:31-32)</b>. It is obeying the demands of righteousness
            for conversion to be qualified to enter the kingdom. It is a change
            of pursuit from the life of the gentile to that which God ordained
            for man. <br />
            <br />
            In seeking the kingdom, our natures are changed from that of a dog
            and a swine, who pursue carnal things <b>(Matt. 7:6)</b>. It is
            upgrading our values for living to rise above treasuring vanity to
            treasuring the kingdom. In seeking the kingdom, we are made
            righteous enough to enter into the kingdom.
          </Content>
        </SubSection>
        <SubSection>
          <Subtitle>Entering the kingdom of God</Subtitle>
          <Content>
            A believer who seeks the kingdom would find the gates into the
            kingdom. At this point, the believer is expected to knock for the
            door to be opened. Knocking the door of the kingdom is making up
            one&rsquo;s mind by the Spirit to live for the kingdom alone{" "}
            <b>(Matt. 13:46)</b>. It is an obedience of selling all you have to
            the poor to follow the Lord <b>(Luke 18:22).</b> <br />
            <br />
            It is giving up one&rsquo;s definitions of hopes and aspirations in
            the world to finally be separated unto the life of the kingdom. It
            is to give up all earthly hopes and ambitions to now begin to live
            to express God&rsquo;s life in one&rsquo;s soul. As the Levites were
            separated from the rest of the children of Israel unto God, such a
            believer has determined to be separated unto the tabernacle or the
            kingdom <b>(Num. 8:14-15)</b>.<br />
            <br /> The Lord Jesus would not minister entrance to a believer who
            still regards the things of the world above the things of the
            kingdom <b>(Matt. 7:6)</b>. He would not give holy things to dogs or
            costly pearls to swine. Entering into the kingdom is synonymous to
            entering the court of the tabernacle.
          </Content>
        </SubSection>
      </Section>
      <Section>
        <SubSection>
          <Title>Conclusion</Title>
          <Content>
            By God&rsquo;s grace, today, we have been able to comprehend what
            the eternal purpose of man is; the right definitions of kingdom; and
            how the believer hears, sees, seeks, and enters the kingdom of God.
            We trust that the Lord, through his Spirit has spurred our desire to
            seek and enter his kingdom. Next, we seek to properly expound the
            kingdom of Christ and of God in more details.
          </Content>
        </SubSection>
      </Section>
      <WithLove />
    </>
  );
}
